<template>
  <div class="pc-container">
    <div class="pc-header" :class="{ isHideAd: isHideAd }">
      <h3c-header-ad
        v-if="showAd"
        ref="headerAdRef"
        :class="{ 'pc-header-ad': true, hide: isHideAd, show: !isHideAd }"
        @closeAd="handleClickCloseAd"
      ></h3c-header-ad>
      <h3c-header :prop-class="{ 'pc-header-h3c': true, top: isHideAd }"></h3c-header>
    </div>
    <authentication-two
      v-model:visible="visibleTwo"
      :canClose="canClose"
      @update:visible="handleVisibleTwoChange"
    />
    <router-view></router-view>
    <div class="pc-footer">
      <h3c-footer></h3c-footer>
    </div>
  </div>
</template>

<script>
import h3cHeader from './components/h3cHeader/h3cHeader'
import authenticationTwo from '@/views/pc/components/authenticationTwo'
import h3cHeaderAd from './components/h3cHeader/h3cHeaderAd'
import h3cFooter from './components/h3cFooter/h3cFooter'
import { onMounted, ref, getCurrentInstance, onBeforeUnmount } from 'vue'
export default {
  components: {
    h3cHeader,
    h3cHeaderAd,
    authenticationTwo,
    h3cFooter
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const showAd = ref(true)
    const isClick = ref(false)
    const isHideAd = ref(false)
    const visibleTwo = ref(false)
    const headerAdRef = ref(null)
    const canClose = ref(true)
    proxy.$bus.on('reservation.event', (eventInfo) => {
      console.log(eventInfo)
    })
    function handleScroll() {
      const adElem = headerAdRef.value?.$el
      if (adElem) {
        const adHeight = adElem.clientHeight
        if (window.scrollY >= adHeight) {
          headerAdRef.value.showQrcode = false
          isHideAd.value = true
        } else {
          isHideAd.value = false
        }
      }
    }
    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
      document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)
    })
    onBeforeUnmount(() => {
      window.removeEventListener('scroll', handleScroll)
    })
    const handleVisibleTwoChange = (visible) => {
      if (Array.isArray(visible)) {
        visibleTwo.value = visible[0]
        canClose.value = close[1]
      } else {
        visibleTwo.value = visible
      }
    }
    proxy.$bus.on('changeAuthenticationTwo', handleVisibleTwoChange)
    return {
      showAd,
      isHideAd,
      headerAdRef,
      visibleTwo,
      handleVisibleTwoChange,
      handleClickCloseAd() {
        showAd.value = false
        isClick.value = false
      }
    }
  }
  // metaInfo() {
  //   return {
  //     title: 'PC首页',
  //     meta: [
  //       { name: 'description', content: '这是我的PC首页' },
  //       { name: 'keywords', content: 'vue, PC, 首页' }
  //     ]
  //   }
  // }
}
</script>

<style scoped>
.pc-container {
  position: relative;
  background: linear-gradient(180deg, #070a11 0%, #0f1a4d 100%);
  /*padding-top: 96px;:style="{ 'padding-top': !showAd ? '0px' : '96px' }"*/
  /*width: calc(100vw - (var(--scrollbar-width)));*/
  /*min-width: 1640px;*/
  min-width: 1360px; /* no-pxtorem */
  /*background-image: url('../../assets/images/footer-bac.png');*/
  /*background-size: contain;*/
  /*background-repeat: no-repeat;*/
  /*background-position-y: 100%;*/
}
.pc-header {
  width: 100%;
  height: 0;
  position: sticky;
  top: 0;
  z-index: 10;
  margin-bottom: 176px;
}
.pc-header.isHiedAd {
  margin-bottom: 80px;
}
.pc-header-ad {
  z-index: 999;
}
.pc-header-ad.hide {
  animation: hide 0.5s ease forwards;
}
.pc-header-ad.show {
  animation: show 0.5s ease forwards;
}
.pc-header-h3c.top {
  transform: translateY(-96px);
  transition: all 0.5s ease;
}
@keyframes hide {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-100%);
  }
}
@keyframes show {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>
